// extracted by mini-css-extract-plugin
module.exports = {"IntroDescription":"IntroDescription_IntroDescription__1nDDA"};